var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue2-org-tree',{attrs:{"data":_vm.data,"label-class-name":_vm.labelClassName,"collapsable":"","renderContent":_vm.renderContent},on:{"on-expand":_vm.onExpand,"on-node-click":_vm.NodeClick,"on-node-mouseover":_vm.onMouseover,"on-node-mouseout":_vm.onMouseout}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67081c32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orgtree.vue
// module id = null
// module chunks = 